'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('toggleClass',
			[
				'$timeout', function($timeout) {
					return {
						restrict: 'A',
						link: function(scope, element, attrs) {
							element.bind('click',
								function(e) {
									var parent = element.parent();
									e.preventDefault();
									if (parent.hasClass(attrs.toggleClass)) {
										return;
									}
									parent.addClass(attrs.toggleClass);
									$timeout(function() {
										$(document)
											.one('click',
												function() {
													parent.removeClass(attrs.toggleClass);
												});
									},
									0);
								});
						}
					};
				}
			]);
})();
